import { Component, OnInit, EventEmitter, Output, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Picker } from '../picker';
import * as moment_ from 'moment';


@Component({
  selector: 'ts-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss', '../../style.scss']
})
export class DatePickerComponent extends Picker implements OnInit, OnChanges {
  @Input() date: any;
  isflexible: any;
  monthData = null;
  dayWords = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
  monthsWords = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  daysCount = -1;
  selectedDateValue: String;
  @Output() newDateSelected = new EventEmitter();
  @Output() checkedFlexible = new EventEmitter();
  showPicker: Boolean = false;
  selectedDate: any = null;
  moment = moment_;
  constructor() {
    super();
  }

  ngOnInit() {
    let today = new Date();
    this.selectedDate = this.createDateObject(this.date);
    if (this.validateDateInput(this.date)) {
      let year = this.moment(this.date).get('year');
      let month = this.moment(this.date).get('month');
      this.monthData = this.getMonthData(year, month + 1, this.selectedDate);
    } else {
      this.monthData = this.getMonthData(today.getFullYear(), today.getMonth() + 1, this.selectedDate);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes.date) {
    //   this.selectedDate = this.createDateObject(this.date);
    //   this.setSelected(this.selectedDate);
    // }
  }

  flexibleChecked() {
    this.isflexible = !this.isflexible;
    this.checkedFlexible.emit(this.isflexible);
  }

  // componentDidLoad() {
  //     /** Emit the current date */
  //     this.setSelected(this.selectedDate);
  // }

  componentWillUpdate() {
    this.daysCount = -1;
  }

  validateDateInput(date) {
    const dateRegExp = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
    return dateRegExp.test(date);
  }

  createDateObject(date) {
    if (this.validateDateInput(date)) {
      let array = this.date.split('-');
      return { month: parseInt(array[1].replace(/^0+/, '')), date: parseInt(array[2].replace(/^0+/, '')) };
    } else {
      return null;
    }
  }

  getMonthData(year, month, selectedDate) {
    let ret = [];

    let firstDay = new Date(year, month - 1, 1);

    let firstDayWeekDay = firstDay.getDay();

    if (firstDayWeekDay === 0) {

      firstDayWeekDay = 7;
    }

    year = firstDay.getFullYear();

    month = firstDay.getMonth() + 1;


    let lastDayOfLastMonth = new Date(year, month - 1, 0);

    let lastDateOfLastMonth = lastDayOfLastMonth.getDate();

    let preMonthDayCount = firstDayWeekDay - 1;

    let lastDay = new Date(year, month, 0);

    let lastDate = lastDay.getDate();
    let styleCls = '';
    for (let i = 0; i < 7 * 6; i++) {

      let date = i + 1 - preMonthDayCount;

      let showDate = date;

      let thisMonth = month;

      if (date <= 0) {

        thisMonth = month - 1;
        showDate = lastDateOfLastMonth + date;
        styleCls = 'nice-gray';

      } else if (date > lastDate) {
        thisMonth = month + 1;
        showDate = showDate - lastDate;
        styleCls = 'nice-gray';
      } else {

        if (selectedDate !== null) {
          if (date === selectedDate.date && thisMonth === selectedDate.month) {

            styleCls = 'normal-date current-selection';

          } else {
            styleCls = 'normal-date';
          }
        } else {
          let today = new Date();
          if (showDate === today.getDate() && thisMonth === today.getMonth() + 1) {
            styleCls = 'normal-date current-selection';
          } else {
            styleCls = 'normal-date';
          }
        }
      }

      if (thisMonth === 13) {
        thisMonth = 1;
      }
      if (thisMonth === 0) {
        thisMonth = 12;
      }

      ret.push({
        month: thisMonth,
        date: date,
        showDate: showDate,
        styleCls: styleCls
      });
    }
    return {
      year: year,
      month: month,
      date: ret
    };
  }

  changeMonth(direction) {
    this.daysCount = -1;
    let year;
    let month;
    if (this.monthData) {

      year = this.monthData.year;
      month = this.monthData.month;

    }
    if (direction === 'prev') {
      if (this.moment().month() + 1 === this.monthData.month && this.moment().year() === this.monthData.year) {
        return;
      } else {
        month--;
        if (month === 0) {
          month = 12;
          year = year - 1;
        }
      }
    }
    if (direction === 'next') {
      month++;

    }
    this.buildUI(year, month);

  }

  buildUI(year, month) {
    this.monthData = this.getMonthData(year, month, this.selectedDate);
  }

  setSelected(selectedDate) {
    let year = this.monthData.year;
    let month = this.monthData.month;
    this.daysCount = -1;
    this.selectedDateValue = '' + year + '-' + this.numberFormat(selectedDate.month) + '-' + this.numberFormat(selectedDate.date);
    this.newDateSelected.emit(this.selectedDateValue);
    this.monthData = this.getMonthData(year, month, selectedDate);
  }

  numberFormat(number) {
    number = parseInt(number);
    return (number < 10 ? '0' : '') + number;
  }
}
